import React from 'react';
import { ActionCreateNameIcon } from '../../../../../modules/action-create/components/name-icon';
import { useLavvaCreateActionContext } from '../context';
import { useActionCreate } from '../hooks/use-action-create';
import { useActionEdit } from '../hooks/use-action-edit';

const LavvaActionCreateNameIcon: React.FC = () => {
  const { onSubmitNameIcon } = useActionCreate();
  const { name, icon } = useLavvaCreateActionContext();
  useActionEdit();

  return <ActionCreateNameIcon onSubmit={onSubmitNameIcon} name={name} icon={icon} />;
};

export default LavvaActionCreateNameIcon;
